import { Chess } from "chess.js";

export interface VerifiedLine {
  fen: string;
  moves: string[];
  depth: number | null;
}

/** Immutable, legally checked copy of the exact continuation shown to the player. */
export function createVerifiedLine(fen: string, moves: readonly string[], depth: number | null): VerifiedLine | null {
  if (!moves.length) return null;
  try {
    const game = new Chess(fen);
    const uci = moves.map((token) => {
      const move = game.move(token);
      return `${move.from}${move.to}${move.promotion ?? ""}`;
    });
    return { fen, moves: uci, depth };
  } catch {
    return null;
  }
}

export function advanceVerifiedLine(line: VerifiedLine | null, uci: string): VerifiedLine | null {
  if (line?.moves[0] !== uci || line.moves.length < 2) return null;
  try {
    const game = new Chess(line.fen);
    game.move(uci);
    return { ...line, fen: game.fen(), moves: line.moves.slice(1) };
  } catch {
    return null;
  }
}
